import { render, staticRenderFns } from "./RTFooter.vue?vue&type=template&id=1175cd08&scoped=true&"
import script from "./RTFooter.vue?vue&type=script&lang=js&"
export * from "./RTFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175cd08",
  null
  
)

export default component.exports